import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function PlayGameIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 29 29">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1011 0C6.32035 0 0 6.48637 0 14.4691C0 22.4519 6.32035 28.9353 14.1011 28.9353C21.8818 28.9353 28.205 22.4513 28.205 14.4691C28.205 6.48696 21.8823 0 14.1011 0ZM14.1011 1.37829C21.1559 1.37829 26.8615 7.23144 26.8615 14.4691C26.8615 21.7068 21.1561 27.5576 14.1011 27.5576C7.04604 27.5576 1.34293 21.707 1.34293 14.4691C1.34293 7.23126 7.04587 1.37829 14.1011 1.37829Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1019 2.75657C7.80462 2.75657 2.68789 8.00838 2.68789 14.4685C2.68789 20.9289 7.80467 26.1787 14.1019 26.1787C20.3993 26.1787 25.5189 20.929 25.5189 14.4685C25.5189 8.00814 20.399 2.75657 14.1019 2.75657ZM11.472 8.95594H11.4774C11.7 8.96655 11.9159 9.03645 12.107 9.15432L18.8246 13.2894C19.6651 13.8096 19.6651 15.1288 18.8246 15.649L12.107 19.784C11.2414 20.315 10.0766 19.6385 10.0746 18.6039V10.3341C10.0737 9.55978 10.7179 8.92435 11.472 8.95594Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1019 2.75657C7.80462 2.75657 2.68789 8.00838 2.68789 14.4685C2.68789 20.9289 7.80467 26.1787 14.1019 26.1787C20.3993 26.1787 25.5189 20.929 25.5189 14.4685C25.5189 8.00814 20.399 2.75657 14.1019 2.75657ZM11.472 8.95594H11.4774C11.7 8.96655 11.9159 9.03645 12.107 9.15432L18.8246 13.2894C19.6651 13.8096 19.6651 15.1288 18.8246 15.649L12.107 19.784C11.2414 20.315 10.0766 19.6385 10.0746 18.6039V10.3341C10.0737 9.55978 10.7179 8.92435 11.472 8.95594Z"
        fill="white"
      />
    </SvgIcon>
  );
}
